import { createContext } from 'react';

interface I18nContextType {
    currentLanguage: string;
    i18nTheme: {
        get: () => string;
        subscribe: (sub: () => void) => () => void;
    };
}

const I18nContext = createContext<I18nContextType>({
    currentLanguage: '',
    i18nTheme: {
        get: () => 'de',
        subscribe: () => () => {},
    },
});

export default I18nContext;
